import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IError } from 'src/app/models/ierror.interface';

@Injectable({
    providedIn: 'root'
})
export class MessageToastService {

    constructor(private messages: MessageService) { }

    success(caption = '', text = '') {
        this.messages.add(
            {
                severity: 'success',
                summary: caption,
                detail: text
            }
        );
    }

    info(caption = '', text = '') {
        this.messages.add(
            {
                severity: 'success',
                summary: caption,
                detail: text
            }
        );
    }

    error(caption = '', text = '') {
        console.log(`[error]: ${caption}:${text}`);
        this.messages.add(
            {
                severity: 'error',
                summary: caption,
                detail: text
            }
        );
    }

    errorEx(err: any) {
        // console.log(`[error]: ${JSON.stringify(err.err.message)}`);
        this.messages.add(
            {
                severity: 'error',
                summary: err?.message ?? err
            }
        );
    }


    warning(caption = '', text = '') {
        this.messages.add(
            {
                severity: 'warn',
                summary: caption,
                detail: text
            }
        );
    }

    clear() {
        this.messages.clear();
    }
}
